"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _FormGroup = _interopRequireDefault(require("../FormGroup"));

var _excluded = ["name", "label", "help", "placeholder", "options", "className", "tooltip"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MultiSelect = function MultiSelect(_ref) {
  var name = _ref.name,
      label = _ref.label,
      help = _ref.help,
      placeholder = _ref.placeholder,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      tooltip = _ref.tooltip,
      props = _objectWithoutProperties(_ref, _excluded);

  var opts = options.map(function (_ref2, i) {
    var label = _ref2.label,
        value = _ref2.value;
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: i,
      value: value
    }, label);
  });
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name
  }, function (_ref3) {
    var field = _ref3.field,
        form = _ref3.form;
    var error = (0, _formik.getIn)(form.errors, name);

    if (error) {
      var errorFieldName = label ? label : 'This';
      error = error.replace(field.name, errorFieldName);
    }

    props.className = (0, _classnames["default"])('form-control', className);

    if (help) {
      props['aria-describedby'] = "".concat(name, "Help");
    }

    field.onChange = function (e) {
      return form.setFieldValue(name, [].slice.call(e.target.selectedOptions).map(function (option) {
        return option.value;
      }));
    };

    return /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
      name: name,
      label: label,
      help: help,
      error: error,
      tooltip: tooltip
    }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, field, props, {
      disabled: form.isSubmitting,
      multiple: true
    }), placeholder && /*#__PURE__*/_react["default"].createElement("option", {
      value: ""
    }, placeholder), opts));
  });
};

MultiSelect.displayName = 'MultiSelect';
MultiSelect.propTypes = {
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  help: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  placeholder: _propTypes["default"].string,
  options: _propTypes["default"].array.isRequired,
  className: _propTypes["default"].string
};
var _default = MultiSelect;
exports["default"] = _default;